import type { ReactNode } from "react";

import CotizacionesSection from "./sections/CotizacionesSection";
import CostosSection from "./sections/CostosSection";
import { FINANZAS_OPERATIVAS_BASE, FINANZAS_OPERATIVAS_APP_ID } from "./paths";

// ---------------------------------------------------------------------------
// Fuente única de la navegación de Finanzas operativas. Alimenta:
//   - el submenú de la app (FinanzasOperativasLayout)
//   - las rutas anidadas (router/config.tsx vía routes.tsx)
//   - el tile del apps-sidebar (AppsSidebar/appsConfig.tsx)
// Las etiquetas son claves i18n del namespace `common`, resueltas en el layout.
// PR2 agrega: resumen, movimientos, rentabilidad.
// ---------------------------------------------------------------------------

export interface FinanzasNavItem {
  id: string; // segmento de ruta bajo /finanzas-operativas
  labelKey: string; // clave i18n (namespace common)
  icon: string; // remixicon del submenú
  element: ReactNode;
}

export const MENU: FinanzasNavItem[] = [
  {
    id: "cotizaciones",
    labelKey: "finanzasOperativas.menu.cotizaciones",
    icon: "ri-file-list-3-line",
    element: <CotizacionesSection />,
  },
  {
    id: "costos",
    labelKey: "finanzasOperativas.menu.costos",
    icon: "ri-calculator-line",
    element: <CostosSection />,
  },
];

export { FINANZAS_OPERATIVAS_BASE, FINANZAS_OPERATIVAS_APP_ID };

/** Ruta de aterrizaje por omisión. */
export const finanzasOperativasDefaultRoute = `${FINANZAS_OPERATIVAS_BASE}/${MENU[0].id}`;
